import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      companyProfile: {
        COMPANY_OVERVIEW: 'Company Overview',
        INDUSTRY_CLASSIFICATION: 'Industry Classification',
        BOARD_OF_DIRECTOR: 'Board of Directors',
        BOARD_OF_MANAGEMENT: 'Board of Management',
        YEARS_OF_OPERATION: 'Years in Operation',
        NUMBER_OF_EMPLOYEES: 'Number of Employees',
        LISTING_STATUS: 'Listing Status',
        CHARTER_CAPITAL: 'Charter Capital',
        YEARS: 'Years',
        YEAR: 'Year',
        VIETNAMESE_NAME: 'Vietnamese Name',
        INTERNATIONAL_NAME: 'Foreign Name',
        SHORT_NAME: 'Short Name',
        TAX_CODE: 'Tax Code',
        TICKER_SYMBOL: 'Ticker Symbol',
        ENTERPRISE_STATUS: 'Enterprise Status',
        ACCOUNTING_PERIOD: 'Accounting Period',
        LEGAL_FORM: 'Legal Form',
        COMPANY_TYPE: 'Company Type',
        DATE_OF_REGISTRATION: 'Date of Registration',
        LEGAL_REPRESENTATIVE: 'Legal Representative',
        PHONE: 'Phone',
        FAX: 'Fax',
        WEBSITE: 'Website',
        EMAIL: 'Email',
        ADDRESS: 'Address',
        INDUSTRY_CODE: 'Industry Code',
        MAIN_VSIC: 'Main VSIC',
        MAIN_ICB: 'Main ICB',
        NAME: 'Name',
        POSITION: 'Position',
        SHAREHOLDING: 'Shareholding',
        NO_MANAGEMENT_DATA:
          "There is no record of the Company's Board of Management.",
        NO_DIRECTOR_DATA:
          "There is no record of the Company's Board of Directors.",
        companyType: {
          CT: 'Corporate',
          NH: 'Bank',
          CK: 'Securities',
        },
        NUMBER_OF_EMPLOYEES_TOOLTIP: 'Estimation',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      companyProfile: {
        COMPANY_OVERVIEW: 'Thông Tin Cơ Bản',
        INDUSTRY_CLASSIFICATION: 'Phân Loại Ngành',
        BOARD_OF_DIRECTOR: 'Hội Đồng Quản Trị',
        BOARD_OF_MANAGEMENT: 'Ban Lãnh Đạo',
        YEARS_OF_OPERATION: 'Số năm hoạt động',
        NUMBER_OF_EMPLOYEES: 'Số nhân viên',
        LISTING_STATUS: 'Trạng thái niêm yết',
        CHARTER_CAPITAL: 'Vốn điều lệ',
        YEARS: 'Năm',
        YEAR: 'Năm',
        VIETNAMESE_NAME: 'Tên Tiếng Việt',
        INTERNATIONAL_NAME: 'Tên Nước Ngoài',
        SHORT_NAME: 'Tên Viết Tắt',
        TAX_CODE: 'Mã Số Thuế',
        TICKER_SYMBOL: 'Mã Chứng Khoán',
        ENTERPRISE_STATUS: 'Trạng Thái Hoạt Động',
        ACCOUNTING_PERIOD: 'Kỳ Kế Toán',
        LEGAL_FORM: 'Loại Hình Đăng Ký Doanh Nghiệp',
        COMPANY_TYPE: 'Loại Doanh Nghiệp',
        DATE_OF_REGISTRATION: 'Ngày Đăng Ký Kinh Doanh',
        LEGAL_REPRESENTATIVE: 'Người Đại Diện Pháp Luật',
        PHONE: 'Điện thoại',
        FAX: 'Fax',
        WEBSITE: 'Website',
        EMAIL: 'Email',
        ADDRESS: 'Địa Chỉ',
        INDUSTRY_CODE: 'Mã Ngành',
        MAIN_VSIC: 'Ngành Hoạt Động Chính (VSIC)',
        MAIN_ICB: 'Ngành Hoạt Động Chính (ICB)',
        NAME: 'Họ Tên',
        POSITION: 'Chức Vụ',
        SHAREHOLDING: 'Tỷ Lệ Sở Hữu',
        NO_MANAGEMENT_DATA: 'Không có bản ghi về Ban lãnh đạo của công ty này',
        NO_DIRECTOR_DATA:
          'Không có bản ghi về Hội đồng quản trị của công ty này',
        companyType: {
          CT: 'Doanh Nghiệp',
          NH: 'Ngân Hàng',
          CK: 'Chứng Khoán',
        },
        NUMBER_OF_EMPLOYEES_TOOLTIP: 'Ước tính',
      },
    },
  }),
)
